import { useState, useEffect } from 'react';
import {
  Typography,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  alpha,
  TextField,
  Box,
  Switch,
} from '@mui/material';
import FormButtonControls from '@/components/forms/formButtonControls/FormButtonControls';
import DisplaySettingsOutlinedIcon from '@mui/icons-material/DisplaySettingsOutlined';

const CrmFrontendVisibilityForm = ({
  app,
  deployment,
  next,
  back,
  isLastStep,
  isFirstStep,
  handleCancel,
}) => {
  const [hideQuickPartyEntryAction, setHideQuickPartyEntryAction] = useState(
    deployment?.config?.crm?.hideQuickPartyEntryAction ?? false,
  );
  const [hidePartyEntryAction, setHidePartyEntryAction] = useState(
    deployment?.config?.crm?.hidePartyEntryAction ?? false,
  );
  const [hideFullSyncAction, setHideFullSyncAction] = useState(
    deployment?.config?.crm?.hideFullSyncAction ?? false,
  );

  const handleSave = async () => {
    next({
      hideQuickPartyEntryAction,
      hidePartyEntryAction,
      hideFullSyncAction,
    });
  };

  return (
    <Card
      elevation={2}
      sx={{
        borderRadius: 2,
        overflow: 'visible',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      <CardHeader
        avatar={<DisplaySettingsOutlinedIcon color="primary" />}
        title={
          <Typography variant="h6">
            Aktionsmöglichkeiten in der Anwendung
          </Typography>
        }
        subheader={`Für ${app?.title || deployment?.title}`}
        sx={{
          bgcolor: (theme) => alpha(theme.palette.primary.light, 0.1),
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      />
      <CardContent sx={{ pt: 3, pb: 2, flex: 1 }}>
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          Sichtbarkeit der Aktionen steuern:
        </Typography>
        <Box display="flex" flexDirection="column" gap={3}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box>
              <Typography variant="subtitle1" fontWeight="bold">
                "Schneller Partei-Eintrag" Aktion ausblenden
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Blendet die Möglichkeit aus, schnell einen Partei-Eintrag zu
                erstellen.
              </Typography>
            </Box>
            <Box>
              <Switch
                color="primary"
                checked={hideQuickPartyEntryAction}
                onChange={(e) => setHideQuickPartyEntryAction(e.target.checked)}
              />
            </Box>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box>
              <Typography variant="subtitle1" fontWeight="bold">
                "Partei-Eintrag" Aktion ausblenden
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Entfernt die Standardfunktion zum Hinzufügen eines
                Partei-Eintrags.
              </Typography>
            </Box>
            <Box>
              <Switch
                color="primary"
                checked={hidePartyEntryAction}
                onChange={(e) => setHidePartyEntryAction(e.target.checked)}
              />
            </Box>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box>
              <Typography variant="subtitle1" fontWeight="bold">
                "Vollständige Synchronisation" Aktion ausblenden
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Verbirgt die Option, eine vollständige Synchronisation
                durchzuführen.
              </Typography>
            </Box>
            <Box>
              <Switch
                color="primary"
                checked={hideFullSyncAction}
                onChange={(e) => setHideFullSyncAction(e.target.checked)}
              />
            </Box>
          </Box>
        </Box>
      </CardContent>

      <Divider />

      <CardActions sx={{ p: 2, justifyContent: 'flex-end' }}>
        <FormButtonControls
          next={next && handleSave}
          back={back}
          cancel={handleCancel}
          isFirstStep={isFirstStep}
          isLastStep={isLastStep}
        />
      </CardActions>
    </Card>
  );
};

export default CrmFrontendVisibilityForm;
